import React from "react";

import * as S from "./styles";

export const TradicaoMigrante: React.FC = () => {
  return (
    <S.Container>
      <S.Content className="first">
        <S.WrapperAllTexts>
          <S.Title
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="300ms"
          >
            Tradição
            <br />
            migrante
          </S.Title>
          <S.WrapperColumns>
            <S.Column
              className="wow animate__animated animate__fadeIn"
              data-wow-duration="1s"
              data-wow-delay="300ms"
            >
              <p>
                Couro e sola, ilhós e fivela, linha e cola. De receita simples e
                construção complexa, o calçado que ajudou o homem da caatinga a
                vencer distâncias cruzou tempo e espaço para permanecer nos pés
                do nordestino.
              </p>

              <p>
                Nesse avançar, ultrapassou currais e cangaço, migrou para a
                cidade grande, alcançou a urbe, fez morada. Transformou-se
                inclusive no nome, de alpercata para xô boi, em versões
                elaboradas e, de uns tempos para cá, cada vez mais desejadas.
              </p>
            </S.Column>
            <S.Column
              className="wow animate__animated animate__fadeIn"
              data-wow-duration="1s"
              data-wow-delay="300ms"
            >
              <p>
                Das passarelas para as vitrines e do cinema para os museus e
                galerias, ela está em todas: notabilizada como a “sandália de
                Lampião”, a xô boi ganhou fama internacional a partir de meados
                de 2000 ao surgir nos pés de artistas e estilistas e nas páginas
                de livros, revistas e catálogos. O destaque se deve
                essencialmente ao trabalho de Espedito Veloso de Carvalho, o
                Espedito Seleiro, artesão cearense criador das peças de couro
                que chamaram a atenção do mundo, tornando-se a principal
                referência dos designers em suas releituras para o calçado.
              </p>
            </S.Column>
          </S.WrapperColumns>
        </S.WrapperAllTexts>
      </S.Content>
      <S.Photo1>
        <S.WrapperPhoto1Legend>
          <S.PhotoLegend>
            Mestre Espedito Seleiro. Foto: Clival Jr.
          </S.PhotoLegend>
        </S.WrapperPhoto1Legend>
      </S.Photo1>
      <S.Photo1Mobile
        className="wow animate__animated animate__zoomIn"
        data-wow-duration="1s"
      />
      <S.PhotoLegendMobile>
        Mestre Espedito Seleiro. Foto: Clival Jr.
      </S.PhotoLegendMobile>
      <S.Content>
        <S.WrapperAllTexts>
          <S.Title
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="300ms"
          >
            Técnica e<br />
            organicidade
          </S.Title>
          <S.WrapperColumns>
            <S.Column
              className="wow animate__animated animate__fadeIn"
              data-wow-duration="1s"
              data-wow-delay="300ms"
            >
              <p>
                Inscrito nas tradições do semiárido nordestino, mestre Espedito
                levou seu referencial de vida às sandálias outrora também
                fabricadas pelo pai.
              </p>

              <p>
                Seu Raimundo Seleiro, aliás, desenhou e produziu o par de xô boi
                mais conhecido entre os adotados por Lampião – o de sola
                quadrada, um recurso criado para impedir a identificação, pelas
                tropas volantes, da direção na qual o bando se deslocava.
                Autodidata, o artesão domina como ninguém o design intuitivo,
                aquele que nasce de vivências e se manifesta da relação com a
                paisagem.{" "}
              </p>
            </S.Column>
            <S.Column
              className="wow animate__animated animate__fadeIn"
              data-wow-duration="1s"
              data-wow-delay="300ms"
            >
              <p>
                Reflexos da operação artístico-utilitária realizada por mestre
                Espedito estão no efeito produzido pelas cores aplicadas nas
                peças e no ritmo elegante de suas formas não lineares, que
                acabam por se harmonizar na estrutura geral do calçado. É como
                se tais padrões houvessem sempre estado ali, em seu lugar
                natural. “Quando eu quero uma cor diferente, que eu não sei o
                nome, eu mesmo faço”, já disse, em entrevista, um pragmático
                Espedito Seleiro, demonstrando, meio sem querer, o quanto há de
                técnica, mas também de organicidade, em seu processo criativo.
              </p>
            </S.Column>
            <S.Column
              className="wow animate__animated animate__fadeIn"
              data-wow-duration="1s"
              data-wow-delay="300ms"
            >
              <p>
                Agraciado com o título de notório saber em cultura popular pelas
                Universidades Federal e Estadual do Ceará, mestre Espedito
                Seleiro é um vetor da sabedoria do homem da caatinga.
              </p>

              <p>
                Mais importante do que sua condição de fiel depositário de um
                modo de fazer ancestral, é sua disposição para reverberar as
                tradições da civilização do couro, aquela que, em suas criações,
                ganhou fôlego não apenas para habitar, mas para interagir na
                vida contemporânea.
              </p>
            </S.Column>
          </S.WrapperColumns>
        </S.WrapperAllTexts>
      </S.Content>
    </S.Container>
  );
};
